export const SET_USER_EMAIL = 'SET_USER_EMAIL';
export const SET_USER_OBJECT = 'SET_USER_OBJECT';
export const SET_USER_ATTRIBUTES = 'SET_USER_ATTRIBUTES';
export const SET_OBSERVATION_OBJECT = 'SET_OBSERVATION_OBJECT';
export const SET_COLUMN_SORT_SETTINGS = 'SET_COLUMN_SORT_SETTINGS';
export const SET_COLUMN_FILTER_SETTINGS = 'SET_COLUMN_FILTER_SETTINGS';
